import { createTranslator } from 'short-uuid';

const translator = createTranslator();

/**
 * Encode a UUID to a base58 short ID (22 chars). Fully reversible.
 * @param {string} uuid
 * @returns {string}
 */
export const toShortUuid = uuid => translator.fromUUID(uuid);

/**
 * Decode a base58 short ID back to a full UUID.
 * @param {string} shortId
 * @returns {string}
 */
export const fromShortUuid = shortId => translator.toUUID(shortId);

/**
 * Derive a human-readable display ID from a transaction UUID.
 * Takes the last 7 hex characters of the UUID (dashes stripped): the most
 * random/variable portion: upper-cased and formatted as "XXX-XXXX".
 *
 * e.g. "...877e8319fd53" → strip dashes → "...877e8319fd53"
 *                        → last 7       → "9fd53" (wait, 7) → "319fd53"
 *                        → uppercase   → "319FD53"
 *                        → format      → "319-FD53"
 *
 * @param {string} uuid - Full UUID string
 * @returns {string} e.g. "319-FD53"
 */
export const toHumanTxId = uuid => {
  const hex = (uuid || '').replace(/-/g, '').slice(-7).toUpperCase();
  return hex.replace(/^(.{3})(.{4})$/, '$1-$2');
};
